import { render, staticRenderFns } from "./commonSetting.vue?vue&type=template&id=b8d3772e&scoped=true&"
import script from "./commonSetting.vue?vue&type=script&lang=js&"
export * from "./commonSetting.vue?vue&type=script&lang=js&"
import style0 from "./commonSetting.vue?vue&type=style&index=0&id=b8d3772e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d3772e",
  null
  
)

export default component.exports